module.exports = __webpack_public_path__ + "static/img/90.25772c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/25/90.jpg
// module id = 748
// module chunks = 0